import styled from 'styled-components';

export const AttrName = styled.div`
  font-weight: bold;
  font-size: 14;
`
export const Attr = styled.div`
  font-size: 14;
`